var smsRelativePath = '/sms';
export var createSmsApi = function (baseUrl, http) {
    var smsApiUrl = baseUrl + smsRelativePath;
    return {
        sendAgentMessage: function (smsDto) { return http.post("".concat(smsApiUrl, "/message"), smsDto); },
        createAgentSmsTickets: function (outboundSmsDto) { return http.post("".concat(smsApiUrl, "/tickets/outbound"), outboundSmsDto); },
    };
};
//# sourceMappingURL=index.js.map